import { useEffect, useRef, useState } from 'react';
import { ellipsizeToFit } from '../lib/ellipsizeToFit';

export function useEllipsizedText({ text, maxHeightPx }) {
  const ref = useRef(null);
  const [state, setState] = useState({
    text: String(text ?? ''),
    isTruncated: false,
  });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let rafId = 0;
    let isCancelled = false;

    const run = async () => {
      if (!ref.current) return;
      const result = await ellipsizeToFit({
        element: ref.current,
        fullText: text,
        maxHeightPx,
      });

      if (isCancelled) return;
      setState(result);
    };

    const schedule = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        run();
      });
    };

    schedule();

    const observer = new ResizeObserver(() => schedule());
    observer.observe(el);

    return () => {
      isCancelled = true;
      cancelAnimationFrame(rafId);
      observer.disconnect();
    };
  }, [maxHeightPx, text]);

  return {
    ref,
    text: state.text,
    isTruncated: state.isTruncated,
  };
}
